import { buildLocalPage } from "./_localPageBuilder";

export default buildLocalPage({
  slug: "tms-boca-raton",
  cityName: "Boca Raton",
  county: "Palm Beach County",
  distance: "20 minutes north",
  title: "TMS Treatment in Boca Raton, Florida",
  description:
    "TMS, SAINT®, and SPRAVATO® treatment for Boca Raton residents at our Coral Springs center. Serving Palm Beach County. Schedule a consultation today.",
  keywords:
    "TMS Boca Raton, TMS therapy Boca Raton, SAINT Boca Raton, depression treatment Boca Raton, Neuro Wellness",
  localContext:
    "Boca Raton residents along Glades Road, Military Trail, and the neighborhoods near Florida Atlantic University are a short drive up the Florida Turnpike or I-95 to our Coral Springs center — roughly 20 minutes north in light traffic. Many Boca patients find it easier to travel here for accelerated protocols like SAINT®, which can be completed in a single week, than to commit to six weeks of daily appointments closer to home. We also see Boca Raton patients who have tried multiple antidepressants without adequate relief and are exploring non-medication options such as TMS, SPRAVATO®, and IV ketamine.",
});
